import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap'
import ErrorMessage from '../../../../components/comman/ErrorMessage'
import { useForm } from 'react-hook-form';
import { formatAmount, parseAmount } from '../../../../utility/CommonFunctions';
import { useLocation } from 'react-router-dom';
import { callApi } from '../../../../ApiHelper/ApiHelper';
import { apiUrl } from '../../../../ApiHelper/ApiUrl';

export default function EditItemModel({ modal, toggle, modalData, type, getSiteItems }) {
    // console.log("modalData======>", modalData)
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: { errors },
        setError,
        clearErrors
    } = useForm();
    const itemTypes = {
        "Supply Budget": "supplyBudget",
        "Service Budget": "serviceBudget",
        "General Expense Head": "generalBudget",
        "Staff Budget": "staffBudget"
    }

    useEffect(() => {
        if (modalData?.actionMode === "Edit") {
            setValue("items", modalData?.item);
            if (type === "Staff Budget") {
                setValue("month", modalData?.month);
            }
            setValue("quantity", modalData?.quantity);
            setValue("unitRate", modalData?.rate);
            setValue("amount", modalData?.amount);
        } else {
            reset()
        }
    }, [modal])

    const onSubmit = (data) => {
        const postData = {
            siteId: location?.state?.data?.id,
            ...(modalData?.actionMode === "Edit" ? { siteBudgetItemId: modalData?.siteBudgetItemId } : { siteBudgetId: modalData?.siteBudgetId }),
            quantity: +data?.quantity,
            unitRate: +data?.unitRate,
            ...(type === "Staff Budget" ? { month: +data?.month, designationId: data?.items } : { itemId: data?.items }),
            total: parseAmount(data?.amount)
        }
        // console.log("postdata======>", postData);

        setIsLoading(true);
        callApi(apiUrl.update_site_budget, {
            method: "POST",
            data: postData
        }).then((response) => {
            setIsLoading(false);
            if (response?.status) {
                getSiteItems(itemTypes[type]);
                closeHandler();
            }
        })
    }

    // console.log(modalData, location?.state?.data?.id)

    const closeHandler = () => {
        reset();
        toggle()
    }

    const getTotalAmount = (rate, quantity, month) => {
        // console.log(rate, quantity)
        const amount = type === "Staff Budget" ? rate * quantity * month : rate * quantity;
        setValue("amount", formatAmount(amount))
    }

    return (
        <Modal
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
            isOpen={modal}
            toggle={closeHandler}
            centered
        >
            <ModalHeader toggle={closeHandler}>
                <h3>{modalData?.actionMode} {type}</h3>
            </ModalHeader>

            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalBody className="text-center p-4">
                    <div className="modal-content">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="tds" className="form-label">
                                    {type === "Staff Budget" ? "Designation" : "Item Name"}
                                </label>
                                <div className="form-group mb-3">
                                    <select
                                        className="form-control form-select"
                                        {...register("items")}
                                        disabled={modalData?.actionMode === "Edit"}
                                    >
                                        <option value="" className="d-none">
                                            Select Item
                                        </option>
                                        {modalData?.itemsData?.length > 0 ? (
                                            modalData?.itemsData?.map((items) => {
                                                return (
                                                    <option
                                                        key={items.id}
                                                        value={items.id}
                                                        disabled={modalData?.selectedValue?.includes(
                                                            items.id
                                                        )}
                                                    >
                                                        {items.name}
                                                    </option>
                                                );
                                            })
                                        ) : (
                                            <option disabled value="">
                                                No items found in selected Expense Head
                                            </option>
                                        )}
                                    </select>
                                </div>
                                <ErrorMessage message={errors?.items?.message} />
                            </div>

                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="erning" className="form-label">
                                        Quantity
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Quantity"
                                        {...register("quantity", {
                                            required: "This field is Required",
                                            ...(modalData?.actionMode === "Edit" && {
                                                min: {
                                                    value: +modalData?.freezedQuantity || 0,
                                                    message: `Minimum allowed value is ${modalData?.freezedQuantity || 0}`,
                                                },
                                            }),
                                        })}
                                        min={0}
                                        onChange={(e) => {
                                            let value = e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1");

                                            if (!/^\d*\.?\d*$/.test(value)) {
                                                value = "";
                                            }

                                            e.target.value = value;

                                            const numericValue = +value;
                                            const freezedQuantity = +modalData?.freezedQuantity || 0;
                                            // console.log(freezedQuantity)

                                            if (modalData?.actionMode === "Edit") {
                                                if (numericValue < freezedQuantity) {
                                                    setError("quantity", {
                                                        type: "manual",
                                                        message: `Minimum allowed value is ${freezedQuantity}`,
                                                    });
                                                } else {
                                                    clearErrors("quantity");
                                                }
                                            }

                                            getTotalAmount(+watch("unitRate"), numericValue, +watch("month"));
                                        }}
                                    />
                                </div>
                                <ErrorMessage message={errors?.quantity?.message} />
                            </div>
                            {type === "Staff Budget" && <div className="col-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="earning" className="form-label">
                                        Month
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Month"
                                        {...register("month", {
                                            required: "This field is Required",
                                        })}
                                        onChange={(e) => {
                                            let value = e.target.value.replace(/[^0-9]/g, ""); // Allow only digits (whole numbers)
                                            e.target.value = value;
                                            getTotalAmount(+watch("unitRate"), +watch("quantity"), +e.target.value);
                                        }}
                                    />
                                </div>
                                <ErrorMessage message={errors?.month?.message} />
                            </div>}
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="erning" className="form-label">
                                        Unit Rate
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Unit Rate...."
                                        {...register("unitRate", {
                                            required: "This field is Required",
                                            ...(modalData?.actionMode === "Edit" && {
                                                min: {
                                                    value: modalData?.rate || 0,
                                                    message: `Minimum allowed value is ${modalData?.rate || 0}`,
                                                },
                                            }),
                                        })}
                                        onChange={(e) => {
                                            let value = e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1");

                                            if (!/^\d*\.?\d*$/.test(value)) {
                                                value = "";
                                            }

                                            e.target.value = value;

                                            const numericValue = +value;
                                            const unitRate = modalData?.rate || 0;

                                            if (modalData?.actionMode === "Edit") {
                                                if (numericValue < unitRate) {
                                                    setError("unitRate", {
                                                        type: "manual",
                                                        message: `Minimum allowed value is ${unitRate}`,
                                                    });
                                                } else {
                                                    clearErrors("unitRate");
                                                }
                                            }
                                            getTotalAmount(+e.target.value, +watch("quantity"), +watch("month"))
                                        }}
                                    />
                                </div>
                                <ErrorMessage message={errors?.unitRate?.message} />
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="erning" className="form-label">
                                        Amount
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Amount..."
                                        disabled
                                        {...register("amount", {
                                            required: "This field is Required",
                                        })}
                                    />
                                </div>
                                <ErrorMessage message={errors?.amount?.message} />
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={closeHandler}
                    >
                        Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                        {isLoading ? <Spinner /> : "Save"}
                    </button>
                </ModalFooter>
            </form>
        </Modal >
    )
}
